import { render, staticRenderFns } from "./icon-diagram2-folder.vue?vue&type=template&id=7fe8d163&"
import script from "./icon-diagram2-folder.vue?vue&type=script&lang=ts&"
export * from "./icon-diagram2-folder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports